/**
 * Web Bluetooth ESC/POS Printer Service
 *
 * Imprime direto pelo navegador via Web Bluetooth API.
 * Nao precisa de app nativo (Capacitor).
 *
 * Otimizado para: Mobileprinter Mprinter-58MMB (58mm, BLE)
 * Service UUID: 0000ff00  |  Write Char: 0000ff02
 * Largura: 384 dots (203dpi), 32 colunas (Font A 12x24)
 */

// ========== ESTADO ==========

var _device = null
var _server = null
var _writeCharacteristic = null
var _deviceName = null

// UUIDs comuns de impressoras ESC/POS BLE (tentamos todos)
var KNOWN_SERVICE_UUIDS = [
  '0000ff00-0000-1000-8000-00805f9b34fb',
  'e7810a71-73ae-499d-8c15-faa9aef0c3f2',
  '49535343-fe7d-4ae5-8fa9-9fafd205e455',
  '000018f0-0000-1000-8000-00805f9b34fb'
]

var KNOWN_WRITE_CHAR_UUIDS = [
  '0000ff02-0000-1000-8000-00805f9b34fb',
  'bef8d6c9-9c21-4c9e-b632-bd58c1009f9f',
  '49535343-8841-43f4-a8d4-ecbe34729bb3',
  '00002af1-0000-1000-8000-00805f9b34fb'
]

// ========== ESC/POS COMMANDS ==========

var ESC = 0x1B
var GS = 0x1D
var LF = 0x0A

function textToBytes (text) {
  var bytes = []
  for (var i = 0; i < text.length; i++) {
    var code = text.charCodeAt(i)
    if (code < 128) {
      bytes.push(code)
    } else {
      // Caracteres acentuados -> substitui por ASCII simples
      bytes.push(mapAccent(code))
    }
  }
  return bytes
}

function mapAccent (code) {
  // Mapa de caracteres acentuados -> ASCII simples
  var map = {}
  // a acentuado
  map[225] = 97
  map[224] = 97
  map[226] = 97
  map[227] = 97
  map[228] = 97
  // e acentuado
  map[233] = 101
  map[232] = 101
  map[234] = 101
  map[235] = 101
  // i acentuado
  map[237] = 105
  map[236] = 105
  map[238] = 105
  map[239] = 105
  // o acentuado
  map[243] = 111
  map[242] = 111
  map[244] = 111
  map[245] = 111
  map[246] = 111
  // u acentuado
  map[250] = 117
  map[249] = 117
  map[251] = 117
  map[252] = 117
  // c cedilha
  map[231] = 99
  // A acentuado
  map[193] = 65
  map[192] = 65
  map[194] = 65
  map[195] = 65
  // E acentuado
  map[201] = 69
  map[200] = 69
  map[202] = 69
  // I acentuado
  map[205] = 73
  map[204] = 73
  map[206] = 73
  // O acentuado
  map[211] = 79
  map[210] = 79
  map[212] = 79
  map[213] = 79
  // U acentuado
  map[218] = 85
  map[217] = 85
  map[219] = 85
  // C cedilha
  map[199] = 67
  return map[code] || 63 // 63 = '?'
}

function buildStorageLabelCommands (data) {
  var bytes = []
  // 58mm = 32 colunas (Font A 12x24)
  var separator = '================================'

  // Reset printer
  bytes.push(ESC, 0x40)

  // Seleciona code page PC858 (suporte a acentos, caso a impressora suporte)
  bytes.push(ESC, 0x74, 19)

  // === VIA 1: ETIQUETA DO PARTICIPANTE ===

  // Center align
  bytes.push(ESC, 0x61, 0x01)

  // Titulo pequeno
  bytes = bytes.concat(textToBytes('GUARDA-VOLUME'))
  bytes.push(LF)

  // Separator
  bytes = bytes.concat(textToBytes(separator))
  bytes.push(LF)

  // Codigo em destaque: Bold + Double size
  bytes.push(ESC, 0x45, 0x01)
  bytes.push(GS, 0x21, 0x11) // double width + double height
  bytes = bytes.concat(textToBytes('#' + data.code))
  bytes.push(LF)

  // Reset size + bold off
  bytes.push(GS, 0x21, 0x00)
  bytes.push(ESC, 0x45, 0x00)

  // Tipo do item - bold
  bytes.push(ESC, 0x45, 0x01)
  bytes = bytes.concat(textToBytes(data.typeName || 'Item'))
  bytes.push(LF)
  bytes.push(ESC, 0x45, 0x00)

  // Nome do participante
  bytes = bytes.concat(textToBytes(data.participantName || ''))
  bytes.push(LF)

  // Data/hora
  bytes = bytes.concat(textToBytes(data.dateTime || ''))
  bytes.push(LF)

  // Separator
  bytes = bytes.concat(textToBytes(separator))
  bytes.push(LF)

  // Feed para destacar (58mm sem guilhotina)
  bytes.push(LF, LF, LF, LF)

  // === VIA 2: ETIQUETA DO ITEM ===

  // Center align
  bytes.push(ESC, 0x61, 0x01)

  bytes = bytes.concat(textToBytes('GUARDA-VOLUME'))
  bytes.push(LF)

  bytes = bytes.concat(textToBytes(separator))
  bytes.push(LF)

  // Codigo em destaque
  bytes.push(ESC, 0x45, 0x01)
  bytes.push(GS, 0x21, 0x11)
  bytes = bytes.concat(textToBytes('#' + data.code))
  bytes.push(LF)

  bytes.push(GS, 0x21, 0x00)
  bytes.push(ESC, 0x45, 0x00)

  // Tipo do item
  bytes.push(ESC, 0x45, 0x01)
  bytes = bytes.concat(textToBytes(data.typeName || 'Item'))
  bytes.push(LF)
  bytes.push(ESC, 0x45, 0x00)

  // Data/hora
  bytes = bytes.concat(textToBytes(data.dateTime || ''))
  bytes.push(LF)

  bytes = bytes.concat(textToBytes(separator))
  bytes.push(LF)

  // Feed final
  bytes.push(LF, LF, LF, LF)

  return new Uint8Array(bytes)
}

// ========== BLE HELPERS ==========

function findWriteCharacteristic (server) {
  var serviceIndex = 0

  function tryNextService () {
    if (serviceIndex >= KNOWN_SERVICE_UUIDS.length) {
      // Fallback: tenta descobrir servicos disponiveis
      return discoverServices(server)
    }

    var uuid = KNOWN_SERVICE_UUIDS[serviceIndex++]
    return server.getPrimaryService(uuid)
      .then(function (service) {
        return findCharInService(service)
      })
      .catch(function () {
        return tryNextService()
      })
  }

  return tryNextService()
}

function findCharInService (service) {
  var charIndex = 0

  function tryNextChar () {
    if (charIndex >= KNOWN_WRITE_CHAR_UUIDS.length) {
      // Tenta pegar todas as characteristics e achar uma com write
      return service.getCharacteristics()
        .then(function (chars) {
          for (var i = 0; i < chars.length; i++) {
            var props = chars[i].properties
            if (props.write || props.writeWithoutResponse) {
              return chars[i]
            }
          }
          return Promise.reject(new Error('Nenhuma characteristic de escrita encontrada'))
        })
    }

    var uuid = KNOWN_WRITE_CHAR_UUIDS[charIndex++]
    return service.getCharacteristic(uuid)
      .catch(function () {
        return tryNextChar()
      })
  }

  return tryNextChar()
}

function discoverServices (server) {
  // Nao conseguimos listar servicos desconhecidos via Web Bluetooth sem saber o UUID.
  // Se nenhum UUID conhecido funcionou, informa o usuario.
  return Promise.reject(new Error(
    'Nenhum servico de impressao encontrado. Verifique se a impressora esta no modo BLE.'
  ))
}

// ========== WRITE COM CHUNKING ==========

function writeData (characteristic, data) {
  // Mprinter-58MMB: MTU padrao ~20 bytes
  // Usamos chunks pequenos com delay para nao sobrecarregar o buffer da impressora
  var CHUNK_SIZE = 20
  var CHUNK_DELAY = 20 // ms entre chunks
  var offset = 0

  function writeNextChunk () {
    if (offset >= data.length) {
      return Promise.resolve()
    }

    var end = Math.min(offset + CHUNK_SIZE, data.length)
    var chunk = data.slice(offset, end)
    offset = end

    var writePromise
    if (characteristic.properties.writeWithoutResponse) {
      writePromise = characteristic.writeValueWithoutResponse(chunk)
    } else {
      writePromise = characteristic.writeValue(chunk)
    }

    return writePromise.then(function () {
      // Delay entre chunks para a impressora processar
      return new Promise(function (resolve) {
        setTimeout(resolve, CHUNK_DELAY)
      })
    }).then(function () {
      return writeNextChunk()
    })
  }

  return writeNextChunk()
}

// ========== API PUBLICA ==========

function isSupported () {
  return !!(navigator && navigator.bluetooth)
}

function isConnected () {
  return !!(_device && _server && _server.connected && _writeCharacteristic)
}

function getDeviceName () {
  return _deviceName
}

function connect () {
  if (!isSupported()) {
    return Promise.reject(new Error('Web Bluetooth nao suportado neste navegador. Use Chrome ou Edge.'))
  }

  // Se ja esta conectado, retorna
  if (isConnected()) {
    return Promise.resolve(true)
  }

  // Solicita qualquer dispositivo BLE (o usuario escolhe no picker do browser)
  return navigator.bluetooth.requestDevice({
    acceptAllDevices: true,
    optionalServices: KNOWN_SERVICE_UUIDS
  })
    .then(function (device) {
      _device = device
      _deviceName = device.name || 'Impressora BLE'

      // Listener de desconexao
      device.addEventListener('gattserverdisconnected', function () {
        _server = null
        _writeCharacteristic = null
      })

      return device.gatt.connect()
    })
    .then(function (server) {
      _server = server
      return findWriteCharacteristic(server)
    })
    .then(function (characteristic) {
      _writeCharacteristic = characteristic
      return true
    })
    .catch(function (err) {
      _device = null
      _server = null
      _writeCharacteristic = null
      _deviceName = null

      if (err.name === 'NotFoundError') {
        return Promise.reject(new Error('Nenhuma impressora selecionada.'))
      }
      return Promise.reject(err)
    })
}

function disconnect () {
  if (_device && _device.gatt && _device.gatt.connected) {
    _device.gatt.disconnect()
  }
  _device = null
  _server = null
  _writeCharacteristic = null
  _deviceName = null
  return Promise.resolve()
}

/**
 * Imprime etiqueta do guarda-volume via Web Bluetooth
 * @param {Object} data - { code, typeName, participantName, dateTime }
 */
function printStorageLabel (data) {
  if (!isConnected()) {
    return Promise.reject(new Error('Impressora nao conectada.'))
  }

  var commands = buildStorageLabelCommands(data)
  return writeData(_writeCharacteristic, commands)
}

function printSingleLabel (data) {
  return printStorageLabel(data)
}

export default {
  isSupported: isSupported,
  isConnected: isConnected,
  getDeviceName: getDeviceName,
  connect: connect,
  disconnect: disconnect,
  printStorageLabel: printStorageLabel,
  printSingleLabel: printSingleLabel
}
